import { TextFieldProps } from '@hulu/react-style-components';
import React, { forwardRef, Ref } from 'react';

import InputLabel from '../InputLabel';
import { StyledHuluTextField } from './styled';

const TextField = forwardRef(
  ({ label, hideArrows = false, ...rest }: TextFieldProps, ref: Ref<HTMLInputElement>): JSX.Element => {
    const Label = label && <InputLabel key="inputLabel">{label}</InputLabel>;

    return (
      <StyledHuluTextField className={hideArrows ? 'without-number-arrows' : ''} {...rest} label={Label} ref={ref} />
    );
  }
);

export default TextField;
